import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '../../../utils/routes';
import { showToast } from '../../common/Notification';

interface NewsletterStructuredEditorProps {
  newsletterId?: string;
}

const NewsletterStructuredEditor: React.FC<NewsletterStructuredEditorProps> = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Since we only support fixed newsletters now, redirect to the newsletter list
    showToast('info', 'L\'éditeur de newsletter structurée n\'est plus disponible. Seules les newsletters fixes sont supportées.');
    navigate(ROUTES.ADMIN_NEWSLETTER);
  }, [navigate]);

  return (
    <div className="rounded-lg bg-white p-6 shadow-md">
      <div className="text-center">
        <h2 className="mb-4 text-xl font-bold">Redirection en cours...</h2>
        <p className="text-gray-600">
          L'éditeur de newsletter structurée n'est plus disponible. 
          Vous allez être redirigé vers la liste des newsletters fixes.
        </p>
      </div>
    </div>
  );
};

export default NewsletterStructuredEditor; 